import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgWallet = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M15 5.75H7a.75.75 0 0 1 0-1.5h8a.75.75 0 0 1 0 1.5M2.889 7.849A2.17 2.17 0 0 1 4.39 7.25H17.61c.557 0 1.099.212 1.502.599.405.388.639.921.639 1.484v1.774h.536c.887 0 1.607.72 1.607 1.607v2.572c0 .887-.72 1.607-1.607 1.607h-.536v1.774c0 .563-.234 1.096-.639 1.484a2.17 2.17 0 0 1-1.502.599H4.39a2.17 2.17 0 0 1-1.502-.599 2.06 2.06 0 0 1-.639-1.484V9.333c0-.563.234-1.096.639-1.484m15.361 9.044H16c-.888 0-1.607-.72-1.607-1.607v-2.572c0-.887.72-1.607 1.607-1.607h2.25V9.333c0-.144-.06-.289-.176-.401a.67.67 0 0 0-.465-.182H4.39a.67.67 0 0 0-.465.182.56.56 0 0 0-.176.401v9.334c0 .144.06.289.176.401a.67.67 0 0 0 .465.182H17.61c.18 0 .346-.069.465-.182a.56.56 0 0 0 .176-.401zm-2.357-4.179c0-.059.048-.107.107-.107h4.286c.059 0 .107.048.107.107v2.572c0 .059-.048.107-.107.107H16a.107.107 0 0 1-.107-.107z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgWallet;
